export default {"src":"/_next/static/media/nerdLogo.247cbbb5.svg","height":41,"width":120};